import { NavLink } from "react-router-dom";
import { useApi } from "@/hooks/useApi";
import { getPluginNav } from "@/api/endpoints";
import { Icon } from "@/layouts/AppShell";
import { pluginEmbedPath } from "@/lib/pluginLibrary";

/**
 * Sidebar nav items for plugin UIs served through the knotfin origin (#516).
 *
 * Enabled UIProvider/v1 plugins are reverse-proxied by the API under
 * /plugins/{id}/; each entry routes to the in-shell embed (/apps/{id}/) so
 * plugin pages keep the sidebar and theme. Defensive by design: a fetch
 * failure, an empty list, or a malformed entry renders nothing — a broken
 * plugin must never break the shell.
 */
export function PluginNavItems({
  showLabels,
  onNavigate,
}: {
  showLabels: boolean;
  onNavigate?: () => void;
}) {
  const nav = useApi(() => getPluginNav(), []);
  const entries = (nav.data?.data ?? []).filter(
    (entry) =>
      Boolean(entry?.attributes?.ui_url)
      && Boolean(entry?.attributes?.name),
  );
  if (entries.length === 0) return null;
  return (
    <>
      {entries.map((entry) => (
        <NavLink
          key={entry.id}
          to={pluginEmbedPath(entry.attributes.ui_url)}
          className="nav-item"
          onClick={onNavigate}
        >
          <Icon name="tv" />
          {showLabels && <span>{entry.attributes.name}</span>}
        </NavLink>
      ))}
    </>
  );
}
